import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CountryDetail from './components/CountryDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageCountry',
  components: {
    CountryDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;